<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
        <!-- <h2 class="display-4">DASHBOARD PERAKU</h2> -->
    </base-header>

    <div id="printArea">
        <card>
            <div id="content" class="content">
                <b-card-header class="border-0 d-flex justify-content-center">
                    <h1 class="mb-0" style="font-size: 1.4rem; font-weight: bold; text-align: center;">LAPORAN SEMAKAN GAJI </h1>
                </b-card-header>
                <!-- SIMULASI GAJI : <strong>{{ objMaklPer.NamaPegawai }}</strong>
                <br />NO KAD PENGENALAN : <strong> {{ objMaklPer.NoKP }}</strong>
                <br />SKIM / JAWATAN: <strong>{{ objMaklPer.skim.toUpperCase() }}</strong>
                <br />DARI GRED : <strong>{{ objMaklPer.GredBermula310122002 }}</strong>
                <br />HINGGA KE GRED: <strong>{{ objMaklPer.GredAkhir }}</strong>
                <br /><br /> -->
                <div class="info-list">
                    <p>SIMULASI GAJI : <strong>{{ objMaklPer.NamaPegawai }}</strong></p>
                    <p>NO KAD PENGENALAN : <strong>{{ objMaklPer.NoKP }}</strong></p>
                    <p>SKIM / JAWATAN : <strong>{{ objMaklPer.skim.toUpperCase() }}</strong></p>
                    <p>DARI GRED : <strong>{{ objMaklPer.GredBermula310122002 }}</strong></p>
                    <p>HINGGA KE GRED : <strong>{{ objMaklPer.GredAkhir }}</strong></p>
                </div>
                <table border="1" class="styled-table">
                    <thead>
                        <tr>
                            <th style="width: 100px; text-align: center;">BIL</th>
                            <th style="width: 100px; text-align: center;">TARIKH KUATKUASA</th>
                            <th style="width: 300px; text-align: center;">KETERANGAN</th>
                            <th style="width: 100px; text-align: center;">GRED</th>
                            <th style="width: 100px; text-align: center;">TARIKH PERGERAKAN GAJI (TPG)</th>
                            <th style="width: 200px; text-align: center;"><span style="font-size: 12px;">AMAUN TELAH TERIMA (RM) </span><br />
                                <span style="font-size: 10px;">(seperti yang dicatat dalam BPK pegawai)</span></th>
                            <th style="width: 200px; text-align: center;"><span style="font-size: 12px;">AMAUN PATUT TERIMA (RM) </span><br />
                                <span style="font-size: 10px;">(semakan sistem)</span></th>
                            <th style="width: 100px; text-align: center;">TANGGA GAJI</th>
                            <th style="width: 500px; text-align: center;">CATATAN</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in objGajiCO" :key="item.id">
                            <td style="text-align: center; font-weight: bold;">
                                {{ index + 1 }}
                            </td>
                            <td>{{ new Date(item.EftDate).toLocaleDateString('en-GB') }}</td>
                            <td>{{ item.keterangan }}</td>
                            <td>{{ item.SalGrdID }}</td>
                            <td style="text-align: center;">{{ item.TPG }}</td>
                            <td :style="item.AmaunTelahTerima !== item.SalAmtCalc ? 'color:red; font-weight:bold; text-align:center' : 'text-align:center'">
                                {{ item.AmaunTelahTerima }}
                            </td>
                            <!-- <td style="text-align: center;" :class="{ 'text-red-bold': item.AmaunTelahTerima !== item.SalAmtCalc }">
                                {{ item.AmaunTelahTerima }}
                            </td> -->
                            <td style="text-align: center;">{{ item.SalAmtCalc }}</td>
                            <td style="text-align: center;">{{ item.JadualGaji }}</td>
                            <td>{{ item.Catatan }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="report-info">
                    <p>Disediakan oleh : <strong>{{ objMaklPer.pengira }}</strong></p>
                    <p>Agensi / Jabatan / Bahagian : <strong>{{ objMaklPer.bahagian_pengira }}</strong></p>
                    <p>Tarikh Janaan Laporan : <strong>{{ objMaklPer.tarikh_nama_penuh }}</strong></p>

                    <div class="disclaimer">
                        <strong>Disclaimer:</strong>
                        <span>
                            Pegawai Sumber Manusia disarankan untuk menyemak amaun gaji yang telah diterima pegawai sepanjang perkhidmatan
                            supaya ia teratur dengan peraturan berkuat kuasa dan membuat pelarasan yang sewajarnya bagi mana-mana yang berkaitan.
                        </span>
                    </div>
                </div>

            </div>
            <br />
            <!-- Butang Cetak -->
            <base-button size="sm" icon type="primary" class="mb-2" style="font-size: 0.8125rem" @click="printPage">
                <span class="btn-inner--icon"><i class="ni ni-cloud-download-95"></i></span>
                <span class="btn-inner--text">CETAK</span>
            </base-button>
            <base-button size="sm" icon type="success" class="mb-2" style="font-size: 0.8125rem" @click="downloadWord">
                <span class="btn-inner--icon"><i class="ni ni-single-copy-04"></i></span>
                <span class="btn-inner--text">Download Word</span>
            </base-button>
        </card>
    </div>
</div>
</template>

<script>
import swal from "sweetalert2";
import moment from "moment";
import {
    Table,
    TableColumn,
    Pagination
} from "element-ui";
import MDLAddYear from "@/views/Skg/MDLAddYear.vue";
import MDDelYear from "@/views/Skg/MDDelYear.vue";
import Store from "@/store";
import {
    saveAs
} from "file-saver";
import HTMLDocx from "html-docx-js/dist/html-docx";
import GetsalaryService from "@/services/salaryService.js";

export default {
    props: ["ICNo", "coid"],
    name: "light-table",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
            active: false,
            objtahunLatest: {},
            YearRow: {},
            objMaklPer: {},
            objGajiCO: [],
        };
    },
    methods: {
        downloadWord() {
            const content = document.getElementById("printArea").innerHTML;

            const html = `
        <html>
          <head>
            <meta charset="utf-8">
          </head>
          <body>${content}</body>
        </html>
      `;

            const blob = HTMLDocx.asBlob(html);
            saveAs(blob, `Laporan Sistem Semakan Gaji-${this.objMaklPer.NoKP}.docx`);
            //saveAs(blob, "Report.docx");objMaklPer.NoKP
        },
        selesai() {
            // Logik untuk selesai
        },
        printPage() {
            window.print();
        },
        ButiranTahun() {
            let search = {
                currentPage: 1,
                coid: this.objMaklPer.coid,
            };
            GetsalaryService.getButiranTahunInfoParam(search)
                .then((resp) => {
                    this.ClientPaging = resp.data;
                })
                .then(() => {
                    GetsalaryService.getButiranTahunDataParam(search).then((resp) => {
                        this.objGajiCO = resp.data;
                        console.log("objGajiCO", this.objGajiCO);
                    });
                });
        },
    },
    created() {
        let condPenjawatAwam = {
            ICNo: this.ICNo,
            coid: this.coid,
        };

        GetsalaryService.get_MaklLaporanSelesai(condPenjawatAwam)
            .then((resp) => {
                this.objMaklPer = resp.data[0];
                //this.objMaklPer.DtLantikanPertama = moment(this.objMaklPer.DtLantikanPertama, "YYYY-MM-DD").format("DD-MM-YYYY");
            })
            .then(() => {
                this.ButiranTahun();
            })
            .catch((err) => {
                console.log(err);
            });
    },
};
</script>

<style scoped>
.info-list p {
    margin: 5px 0;
    font-family: Arial, sans-serif;
    font-size: 0.95em;
}

strong {
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.info-list strong {
    color: #000;
}

.text-red-bold {
    color: red;
    font-weight: bold;
}

.underline {
    text-decoration: underline;
}

.styled-table {
    border-collapse: collapse;
    margin: 25px 0;
    font-size: 0.9em;
    font-family: "Arial", sans-serif;
    min-width: 400px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
    color: #000;
    /* font hitam */
    font-weight: bold;
    /* boldkan semua teks */
    text-transform: uppercase;
}

.styled-table thead tr {
    background-color: #024052;
    color: #ffffff;
    text-align: left;
}

.styled-table th,
.styled-table td {
    padding: 12px 15px;
}

.styled-table tbody tr {
    border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
    background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
    border-bottom: 2px solid #000706;
}

.styled-table tbody tr.active-row {
    font-weight: bold;
    color: #000504;
}

.uppercase {
    text-transform: uppercase;
    /* Tukar teks kepada huruf besar */
}

.maklumat-pegawai-table {
    font-family: Arial, sans-serif;
    font-size: 14px;
    border-collapse: collapse;
    width: 130%;
    margin-top: 10px;
}

.maklumat-pegawai-table td {
    padding: 8px 10px;
    vertical-align: top;
    color: #000;
    /* Semua teks berwarna hitam */
}

.maklumat-pegawai-table td:nth-child(2) {
    width: 6px;
}

.report-info {
    font-family: Arial, sans-serif;
    font-size: 0.95em;
    line-height: 1.6;
    margin-top: 15px;
}

.report-info p {
    margin: 3px 0;
}

.report-info strong {
    color: #000;
    font-weight: bold;
}

.disclaimer {
    margin-top: 12px;
    padding: 10px;
    background-color: #fff3cd;
    /* kuning lembut */
    border-left: 4px solid #ffc107;
    /* highlight kuning */
    font-size: 0.9em;
}

.disclaimer strong {
    color: #856404;
    /* warna teks untuk perkataan Disclaimer */
}

@media print {
    * {
        color: black;
    }

    /* Sembunyikan elemen dengan kelas .header semasa cetakan */
    .header {
        display: none !important;
    }

    /* Sembunyikan base-header semasa cetakan */
    .base-header {
        display: none !important;
    }

    /* Tukar orientasi kepada lanskap */
    @page {
        size: A4 landscape;
    }

    /* Hide specific elements during print */
    .base-header,
    .base-button {
        display: none;
    }

    .styled-table {
        width: 100%;
        border-collapse: collapse;
    }

    .styled-table th,
    .styled-table td {
        border: 1px solid black;
        padding: 8px;
    }
}
</style>
